
<template>
    <div>
        <div class="xrow">
          <CAlert color="info">
            Como as imagens são utilizadas em plano de fundo, o ideal é enviar em proporções 16:9, tamanho recomendado 1920px x 1080px.
          </CAlert>
          <div v-for="sistema in sistemas" v-bind:key="sistema" class="col col-1-3">
              <CardImage
                :image-url="imageUrl(sistema)"
                :title="sistema.toUpperCase()"
                text="Imagem utilizada no plano de fundo da página de login"
                :upload="() => handleUpload(sistema)"
              />
            </div>
        </div>
    </div>
</template>
<style scoped>
  .image-upload:hover {
    border-color: #333;
  }
</style>

<script>

import _reduce from 'lodash/reduce';
import CardImage from "@/views/Logos/Backgrounds/CardImage.vue";

export default {
  name: 'backgrounds',
  components: {CardImage},
  props: [
    'baseUrl',
    'sistemas',
    'upload',
    'hash',
    'hashs'
  ],
  methods: {
    imageUrl(sistema) {
      return this.baseUrl + sistema + '?no-cache=' + this.hashs[sistema];
    },
    handleUpload(sistema) {
      this.upload('background', { sistema }).then((response) => {
        this.hashs[sistema] = this.hash();
      });
    },
  },
};
</script>
